import { render } from "./Birthday.vue?vue&type=template&id=4c22217d&scoped=true"
import script from "./Birthday.vue?vue&type=script&lang=js"
export * from "./Birthday.vue?vue&type=script&lang=js"

import "./Birthday.vue?vue&type=style&index=0&id=4c22217d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c22217d"]])

export default __exports__